//noScroll
class NavFixed {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

  //   $(function () {
  //   // スクロールを開始したら
  //   $(window).on("scroll", function () {

  //     // ファーストビューの高さを取得
  //     let mvHeight = $(".js-mv").height() + 100;
  //     if ($(window).scrollTop() > mvHeight) {
  //       // スクロールの位置がファーストビューより下の場合にclassを付与
  //       $(".js-navFixed").addClass("is-fixed");
  //     }else {
  //       // スクロールの位置がファーストビューより上の場合にclassを外す
  //       $(".js-navFixed").removeClass("is-fixed");
  //     }

  //     if($(window).scrollTop()  > $(".l-footer").offset().top - 500){
  //       $(".js-navFixed").addClass("is-hidden");
  //     }else{
  //       $(".js-navFixed").removeClass("is-hidden");
  //     }
  //   });
  // });

  }

}
